import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { TaskProvider } from './contexts/TaskContext';
import AuthWrapper from './components/auth/AuthWrapper';
import Header from './components/common/Header';
import TaskManager from './components/pages/TaskManager';
import PriorityView from './components/pages/PriorityView';

const AppContent = () => {
  const { currentUser, loading } = useAuth();

  // Show loading spinner while checking auth
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // NOT logged in: Show ONLY login
  if (!currentUser) {
    return <AuthWrapper />;
  }

  // Logged in: Show ONLY main app (NO login form)
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <TaskProvider>
        <Routes>
          <Route path="/" element={<TaskManager />} />
          <Route path="/priorities" element={<PriorityView />} />
        </Routes>
      </TaskProvider>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;